import { createFileRoute } from '@tanstack/react-router';

import { LandingPageSettingsPage } from '@/areas/settings/manufacturing/OrganizationSettings/LandingPageSettings/LandingPageSettingsPage';
import { canViewCustomerPortalSettings } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/settings/_menu/organization/customer-portal/landing-page')({
    staticData: {
        access: { permissions: canViewCustomerPortalSettings },
        chrome: 'home',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <LandingPageSettingsPage />;
}
